import { useEffect, useState } from "react";
import axios from "axios";
import { TOWN_COORDS } from "./creuseGeo";
import { PEST_CITY_LINK_BY_NAME } from "./pestCities";

export const BUILTIN_TOWNS = Object.entries(TOWN_COORDS).map(([name, pos]) => {
  const href = PEST_CITY_LINK_BY_NAME[name];
  return { key: href.slice(1), name, pos, href, text: "", hidden: false, builtin: true };
});

let cache = null;

export function mergeCommunes(docs) {
  const byKey = Object.fromEntries(docs.map((d) => [d.key, d]));
  const builtin = BUILTIN_TOWNS.map((t) => ({ ...t, text: byKey[t.key]?.text || "", hidden: !!byKey[t.key]?.hidden }));
  const builtinNames = new Set(BUILTIN_TOWNS.map((t) => t.name));
  const added = docs
    .filter((d) => !d.builtin && d.lat != null && !builtinNames.has(d.name))
    .map((d) => ({ key: d.key, name: d.name, pos: [d.lat, d.lng], href: null, text: d.text, hidden: d.hidden, builtin: false }));
  return [...builtin, ...added].sort((a, b) => a.name.localeCompare(b.name, "fr"));
}

export function useCommunes({ includeHidden = false } = {}) {
  const [all, setAll] = useState(cache && !cache.then ? cache : mergeCommunes([]));
  useEffect(() => {
    if (!cache) {
      cache = axios
        .get(`${process.env.REACT_APP_BACKEND_URL}/api/communes`)
        .then((r) => mergeCommunes(r.data))
        .catch(() => mergeCommunes([]));
    }
    Promise.resolve(cache).then((list) => {
      cache = list;
      setAll(list);
    });
  }, []);
  return includeHidden ? all : all.filter((t) => !t.hidden);
}

export function resetCommunesCache() {
  cache = null;
}
